module.exports = __webpack_public_path__ + "img/girl4.0e38e319.jpg";